/* eslint complexity: ["error", 5], max-params: ["error", 7], max-depth: ["error", 2], max-statements: ["error", 11]*/
/* eslint-disable indent */

    var trackingUtils = require('../modules/utils/tracking.utils');
    const FIRST_SEGMENT = 0;
    Odigeo.defineWidget('xsell_preselected_flight', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            fetchSegmentDetails(fareItineraryId, itineraryGroupId, itineraryId, isHubItinerary, isSmartHubItinerary, searchId, wrapper) {
                return this.fetch({
                    url: Odigeo.Settings.property('appContext') + '/widget/itinerary_details',
                    data: {
                        id: 'details-' + [fareItineraryId, itineraryGroupId, itineraryId].join('-'),
                        fareitinerary: fareItineraryId,
                        itinerarygroup: itineraryGroupId,
                        segmentId: itineraryId,
                        isHubItinerary: isHubItinerary,
                        isSmartHubItinerary: isSmartHubItinerary,
                        searchId: searchId,
                    },
                    dataType: 'text',
                    parse: false,
                    success: Odigeo._.bind(this.successFetchSegmentDetails, this, wrapper),
                });
            },

            successFetchSegmentDetails(wrapper, model, data) {
                this.trigger('showSegmentDetails', {
                    wrapper: wrapper,
                    data,
                });
                return this;
            },

            refreshData() {
                this.isEmptyData = false;
                this.refresh();
            },

            afterLoadData(xhr) {
                if (!Odigeo._.isUndefined(xhr)) {
                    this.trigger('rawDataLoaded');
                }
                this.isEmptyData = true;
            },
        }),

        viewClass: Odigeo.View.extend({
            events: {
                'tap .continue_only_flights': 'continueOnlyFlights',
                'tap .ip_one_way_change_search': 'onChangeOneWayAccommodationSearch',
                'tap .flight_details_trigger_button': 'triggerItineraryDetails',
            },

            selectors: {
                baggage: '.xsell_baggage',
                baggageDetail: '.xsell_detail_baggage',
                priceFrom: '.ip_one_way_price_from',
            },

            init() {
                this.bindEvents();
            },

            render() {
                this.$el.html(this.model.rawData);
            },

            postRender() {
                this.addPriceBreakDownPopups();
                this.$el.find(`[data-widget=${this.widget.name}]`).addClass('odf-overflow-hidden');
                if (!Odigeo.AB.isDynpackAndXSellDetailsV1) {
                    this.addFlightDetails();
                }
                this.checkMetas();
                Odigeo.trigger(this.widget.id + ':rendered');
            },

            triggerItineraryDetails(event) {
                const {fareitinerary} = this.$el.find('.itinerary_details').data('itineraryDetails');
                const leg = $(event.target).data('index') || FIRST_SEGMENT;
                const segmentPositions = [{leg, segment: FIRST_SEGMENT}];
                Odigeo.trigger('xsell-preselected-flight:showFlightInfo', {
                    itinerary: {mainItineraryId: fareitinerary},
                    segmentPositions,
                    offset: {top: this.$el.offset().top},
                });
            },

            bindEvents() {
                this.listenTo(this.model, 'rawDataLoaded', this.onRawDataLoaded);
                this.listenTo(this.model, 'showSegmentDetails', this.showItineraryDetails);
                return this;
            },

            onRawDataLoaded() {
                this.refresh();
                Odigeo.trigger(this.widget.id + ':refreshed');
            },

            continueOnlyFlights() {
                const currentAppearances = Odigeo.Session.get('dpupsellactivationrules-manager-appearances');
                const trackingSuffix = this.$el.find('.continue_only_flights').is(':visible') ? '' : 'not_';
                const position = Odigeo._.includes(this.widget.id, 'bottom') ? '_bottom' : '';
                const isPriceWithoutDiscountSelected = this.$el.find('.continue_only_flights').data('is-price-without-discount-selected');

                Odigeo.Session.set('dpupsellactivationrules-manager-appearances',
                    Odigeo._.isEmpty(currentAppearances) ? 1 : (parseInt(currentAppearances, 10) + 1)
                );
                trackingUtils.trackEvent('continue_next_step', 'continue_with_hotel_NO' + position + trackingSuffix);

                Odigeo.trigger(this.widget.id + ':onlyFlightsBook', {isPriceWithoutDiscountSelected: Boolean(isPriceWithoutDiscountSelected)});
            },

            getUpdatedDataWithFlightInfo(data) {
                var segmentKeys = [];

                Odigeo._.each(this.$el.find('[class*=xsell_flight_selection_segment]'), function(segment) {
                    segmentKeys.push($(segment).data('segmentKey'));
                });
                data.fareItineraryKey = this.$el.find('.continue_only_flights').data('fareitinerary');
                data.segmentKeys = segmentKeys;

                return data;
            },

            addPriceBreakDownPopups() {
                var addSectionPriceBreakDownPopups = function(popups, trackingAction, pageEvent) {
                    Odigeo._.each(popups, function(popup) {
                        Odigeo.UIElements.hint.enhance(pageEvent, $(popup), {
                            events: {
                                tap: true,
                            },
                            googleAnalyticsOnOpen: {
                                type: 'trackEvent',
                                data: {
                                    page: pageEvent,
                                    action: trackingAction,
                                    label: 'open_fare_info',
                                },
                            },
                        });
                    });
                };

                addSectionPriceBreakDownPopups(this.$('.popup_price_breakdown'), 'trip_information', Odigeo.History.getPageNameFromFragment());
            },

            addFlightDetails() {
                Odigeo._.each(this.$('.flight_details_btn'), function(popup) {
                    this.loadItineraryDetails(popup);
                    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                        events: {
                            tap: true,
                        },
                        googleAnalyticsOnOpen: {
                            type: 'trackEvent',
                            data: {
                                page: Odigeo.History.getPageNameFromFragment(),
                                action: 'trip_information',
                                label: 'open_segment_info',
                            },
                        },
                        trigger: 'xsell-preselected-flight:loadItineraryDetails',
                    });
                }, this);
            },

            loadItineraryDetails(wrapper) {
                var $itineraryDetails = $(wrapper).find('.itinerary_details');
                var widgetData = $itineraryDetails.data('itinerary-details');
                var segmentKeys = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData')).data.segmentKeys;

                if (!$itineraryDetails.attr('data-loaded')) {
                    var fareItineraryId = widgetData.fareitinerary;
                    var itineraryGroupId = widgetData.itinerarygroup;
                    var itineraryId = parseInt(segmentKeys[itineraryGroupId - 1], 10) + 1;
                    var itineraryIsHub = widgetData.isHub;
                    var itineraryIsSmartHub = widgetData.isSmartHub;
                    var itinerarySearchId = widgetData.searchId;

                    this.model.fetchSegmentDetails(fareItineraryId, itineraryGroupId, itineraryId,
                        itineraryIsHub, itineraryIsSmartHub, itinerarySearchId, wrapper);
                }
            },

            showItineraryDetails(data) {
                var $itineraryDetails = $(data.wrapper).find('.itinerary_details');
                var $productsContainer = this.$widget.closest('.xsell-section').find('.xsell_products_container');

                $itineraryDetails.attr('data-loaded', true);
                $(data.wrapper).find('.itinerary_loader').replaceWith(data.data);
                if ($itineraryDetails.height() > $productsContainer.height()) {
                    $itineraryDetails.addClass('od-xsell-flight-detail');
                }
            },

            checkMetas() {
                var flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
                var $continueButton;

                if (!Odigeo._.isEmpty(Odigeo.Session.get('isMetaForIntermediate'))) {
                    $continueButton = this.$el.find('.continue_only_flights');
                    this.$el.find('.xsell_baggage, .xsell_detail_baggage, .changesearch_link_container, .xsell_details_metas')
                        .removeClass('odf-hidden');
                    this.$el.find('.flight_details_btn').removeClass('od-xsell-details').addClass('od-xsell-details-metas');
                    this.$el.find('.xsell_details').addClass('odf-hidden');
                    flightSelectionData.data.searchId = $continueButton.data('searchid');
                    flightSelectionData.data.fareItineraryKey = $continueButton.data('fareitinerary');
                    Odigeo.Session.set('flightSelectionData', JSON.stringify(flightSelectionData));
                }
            },
            refreshCheapestPrice(cheapestPrice) {
                var cheapestContainer = this.$el.find('.ip_one_way_price_from');

                if (Odigeo._.isEmpty(cheapestContainer.html())) {
                    cheapestContainer.html(Odigeo.Utils.formatCurrency(cheapestPrice));
                }
            },

            onChangeOneWayAccommodationSearch() {
                trackingUtils.trackEvent('ip_one_way', 'change_search');
                Odigeo.trigger(this.widget.id + ':changeOneWaySearch');
            },
        }),

        refreshCheapestPrice() {
            this.view.refreshCheapestPrice.apply(this.view, arguments);
        },

        refresh() {
            this.model.refreshData();
        },

        updatedDataWithFlightInfo() {
            return this.view.getUpdatedDataWithFlightInfo.apply(this.view, arguments);
        },
    }));
